<template>
    <v-container fluid>
        <v-row>
            <v-col lg="6" md="12">
                <UserDetailStatics />
                <MonthlyAverageTime :userId="$route.params.id" />
            </v-col>
            <v-col lg="6" md="12">
                <UserLogs :userId="$route.params.id" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import UserLogs from "../components/UserDetail/UserLogs";
    import UserDetailStatics from "../components/UserDetail/UserDetailStatics";
    import MonthlyAverageTime from "../components/UserDetail/MonthlyAverageTime";
    export default {
        name: "UserDetail",

        components: {
            UserLogs,
            UserDetailStatics,
            MonthlyAverageTime
        }
    }
</script>

<style scoped>

</style>
